 
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

const useStyles = ((theme) => ({
  small_tagChip_skill_dark: {
    display: 'inline-block !important',
    padding: '1px 6px !important',
    margin: '2px 5px 2px 0px !important',
    borderRadius: '10px !important',
    borderStyle: 'solid !important',
    borderWidth: '1px !important',
    borderColor: `${theme.palette.primary.main} !important`,
    textTransform: 'capitalize !important',
    color: `${theme.palette.primary.main} !important`,
  },
  small_tagChip_scouting_dark: {
    display: 'inline-block !important',
    padding: '1px 6px !important',
    margin: '2px 5px 2px 0px !important',
    borderRadius: '10px !important',
    borderStyle: 'solid !important',
    borderWidth: '1px !important',
    borderColor: `${theme.palette.secondary.light} !important`,
    textTransform: 'capitalize !important',
    color: `${theme.palette.secondary.light} !important`,
  },
  smaller_tagChip_skill_dark: {
    fontSize: '0.75rem !important',
    display: 'inline !important',
    textTransform: 'capitalize !important',
    color: `${theme.palette.primary.main} !important`,
  },
  smaller_tagChip_scouting_dark: {
    fontSize: '0.75rem !important',
    display: 'inline !important',
    textTransform: 'capitalize !important',
    color: `${theme.palette.secondary.light} !important`,
  },
}));

const CoChipSmall = React.memo((props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const size = props.size || 'small';
  const tagChipColor = classes[`${size}_tagChip_${props.tagtype}_dark`];

  return <Box com sx={tagChipColor}>{props.label}</Box>;
});

export default CoChipSmall;
